import { getApiErrorMessage } from "@core/utils/apiError"

export interface BotMonitorLoadError {
  kind:
    | "validation"
    | "unauthorized"
    | "forbidden"
    | "unavailable"
    | "http"
    | "network"
    | "timeout"
    | "response"
    | "unknown"
  title: string
  message: string
  httpStatus?: number
}

export const classifyBotMonitorError = (
  error: unknown,
): BotMonitorLoadError => {
  const err =
    error && typeof error === "object" ? (error as Record<string, unknown>) : {}
  const data =
    err.data && typeof err.data === "object"
      ? (err.data as Record<string, unknown>)
      : {}
  // Pick text fields only, never hand UI the transport/request object.
  const message =
    typeof data.message === "string"
      ? data.message
      : Array.isArray(data.message)
        ? data.message.filter(
            (value): value is string => typeof value === "string",
          )
        : undefined
  const text = getApiErrorMessage({
    data: {
      message,
      error: typeof data.error === "string" ? data.error : undefined,
    },
    error: typeof err.error === "string" ? err.error : undefined,
  })
  const status =
    typeof err.status === "number"
      ? err.status
      : typeof err.originalStatus === "number"
        ? err.originalStatus
        : undefined
  if (status !== undefined && status >= 300) {
    const common = { httpStatus: status, message: text }
    if (status === 400)
      return {
        ...common,
        kind: "validation",
        title: "Некорректные параметры запроса",
      }
    if (status === 401)
      return {
        ...common,
        kind: "unauthorized",
        title: "Необходима авторизация",
      }
    if (status === 403)
      return {
        ...common,
        kind: "forbidden",
        title: "Недостаточно прав для просмотра мониторинга",
      }
    if (status === 503 && data.message === "bot-monitor-storage-unavailable")
      return {
        ...common,
        kind: "unavailable",
        title: "Данные мониторинга временно недоступны",
      }
    return {
      ...common,
      kind: "http",
      title: `Ошибка загрузки мониторинга (HTTP ${status})`,
    }
  }
  if (err.status === "FETCH_ERROR")
    return {
      kind: "network",
      title: "Ошибка соединения с сервисом мониторинга",
      message: text,
    }
  if (err.status === "TIMEOUT_ERROR")
    return {
      kind: "timeout",
      title: "Превышено время ожидания ответа",
      message: text,
    }
  if (
    err.status === "PARSING_ERROR" ||
    err.status === "CUSTOM_ERROR" ||
    status === 200
  )
    return {
      kind: "response",
      title: "Некорректный ответ сервиса мониторинга",
      message: "Некорректный ответ сервиса мониторинга",
    }
  return {
    kind: "unknown",
    title: "Ошибка загрузки мониторинга",
    message: text,
  }
}
